<template>
    <div class="get-address">
      <h1>What is your address?</h1>
      <v-card-text>
        <v-text-field
          ref="address"
          v-model="address"
          :rules="[
            () => !!address || 'This field is required',
            addressCheck
          ]"
          label="Address"
          placeholder="Snowy Rock Pl, San Diego"
          required
          variant="outlined"
        ></v-text-field>
        <v-btn
          v-if="address && (!place || address!==place.formatted_address)"
          color="primary"
          @click="fillInAddressFromText"
        >
          Use "{{ address }}"
        </v-btn>
      </v-card-text>
    </div>
    <!-- todo: remove when not needed <p v-if="place">{{ place }}</p> -->
    <!-- <p v-if="place">{{ place }}</p>
    <p v-if="address">{{ address }}</p> -->
</template>

<script>
  /* global google */
  export default {
    name: 'GetAddress',
    data() {
      return {
        address: '',
        place: JSON.parse(localStorage.getItem('mission-place')) || null,
        autocomplete: null
      }
    },
    computed: {
    google_map_url() {
        return 'https://maps.googleapis.com/maps/api/staticmap?size=325x256&amp;zoom=19&amp;scale=1&amp;style=feature:poi%7Cvisibility:off&amp;format=png&amp;maptype=satellite&amp;center='
        +this.place.geometry.location.lat+','+this.place.geometry.location.lng+'&amp;key=GAPIKEY'
      }
    },
    mounted() {
      this.$nextTick(function () {
        if(this.place) {
          console.log("GetAddress mounted");
          console.log(this.place);
          // Emits an event to parent with the data
          this.$emit('send-place', this.place);
        }
        const inputElement = this.$refs.address.$el.querySelector('input');
        this.autocomplete = new google.maps.places.Autocomplete(
          inputElement,
          { types: ['geocode'] }  // This can be ['address'] if you want to limit to addresses only
        );
        this.autocomplete.addListener('place_changed', this.fillInAddress);
      })
    },
    methods: {
      fillInAddressFromText() {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: this.address }, (res, status) => {
          if (status==='OK') {
            this.saveAddress(res[0]);
          }
        });
      },
      fillInAddress() {
        this.saveAddress(this.autocomplete.getPlace());
      },
      saveAddress(address) {
        // persist place to local storage
        localStorage.setItem('mission-place', JSON.stringify(address));
        // pull place from JSON storage object, otherwise lat/lng will return functions not values
        this.place = JSON.parse(localStorage.getItem('mission-place')) || null;
        this.address = this.place.formatted_address;
        // Emits an event to parent with the data
        this.$emit('send-place', this.place);
      },
      addressCheck() {
        // perform some validation on the address, return an error message if invalid
      },
    }
  }
  </script>